import { ComponentHelper } from "../core/util/componentHelper";
import { IsSearchField } from "../core/components/isSearchField";
import { KeyValuePair } from "../commonInterfaces";
import React from "react";

export default class Multiselect extends React.Component<MultiselectProps, MultiselectState> {
    private factory = ComponentHelper.createFactory();

    constructor(props: MultiselectProps) {
        super(props);
        this.state = {
            value: props.dataSource
        };

    }

    private setValue = (value: KeyValuePair<string, string>[]) => {
        this.setState({ value: value }, () => {
            this.props.onChange(this.props.field, value.map((item) => { return item.Key }));
        })
    }

    private renderSearch = () => {
        const props: any = this.factory.getDefaultSearchFieldProps();
        props.value = this.state.value;
        props.onChange = (_, value) => {
            this.setValue(value);
        };
        props.multiSelectMode = true;
        props.field.searchWindowUrl = this.props.field.searchWindowUrl;
        props.field.searchTextField = this.props.field.searchTextField;
        props.field.searchValueField = this.props.field.searchValueField;
        props.field.displayTemplate = "#if(data.Value == null){#<span>#:data.Key#</span>#}else{#<span>#:data.Value# (#:data.Key#)</span>#}#";
        props.field.dataTextField = "Value";
        props.field.dataValueField = "Key";

        
        return (
            <>
                <IsSearchField {...props}/>
            </>
        );
    }

    componentDidUpdate(prevProps: MultiselectProps) {
        if (prevProps.value.length != this.props.value.length && this.props.value.length === 0) {
            this.setValue([]);
        }
    }

    render() {
        return this.renderSearch();
    }

}

interface MultiselectProps {
    dataSource: KeyValuePair<string, string>[];
    field: any;
    onChange: (field, value: string[]) => void;
    value: string[];
}

interface MultiselectState {
    value: KeyValuePair<string, string>[]
}